import { Component, Input, OnInit } from '@angular/core';
import { RegisteredEventsService } from './registered-events.service';
import { ActivityLogs, ActivityLogStatusEnum, SignableType } from '../signing-sidebar/activity-logs/activity-logs-dto';
import { AuthenticationTypeEnum, SigningStatusEnum } from '../enums/enum';
import { RoleDetail } from '../signing-page/signing-page.dto';
@Component({
  selector: 'app-registered-events',
  templateUrl: './registered-events.component.html',
  styleUrl: './registered-events.component.scss'
})
export class RegisteredEventsComponent implements OnInit {
  
  @Input() roleId:string;
  @Input() document_id:number;
  @Input() is_sender:number;
  @Input() roleDetail: RoleDetail;
  
  public $registeredEvents: ActivityLogs[];
  public signingStatusEnum = SigningStatusEnum;
  public authenticationTypeEnum = AuthenticationTypeEnum;
  public activityLogStatusEnum = ActivityLogStatusEnum;
  public signableType = SignableType;
  constructor(private events: RegisteredEventsService){}
  
  ngOnInit(): void {
    this.registerEvents();
  }
  
  private registerEvents(): void {
    this.events.getRegisteredEvents(this.roleId).subscribe({
      next: (events: ActivityLogs[]) => this.$registeredEvents = events
    });
  }
}
